export default __webpack_public_path__ + "ae441c4fa2b1890802eb349f1ce58e2e.svg";